export default "__VITE_ASSET__Dzqpt5xO__"